module.exports = __webpack_public_path__ + "static/media/step5.8b3f86c8.png";